import React, { Component } from "react";
import { TimelineMax } from "gsap";
import { Lethargy } from "lethargy";
import MouseWheel from "../../utils/MouseWheel";

class MapFilters extends Component {
  length = 0;
  pos = 0;
  tl;
  currentFilter;
  curScroll = 0;
  isScrolling = false;
  hasUpdated = false;

  constructor(props) {
    super(props);
    this.state = { progress: 0 };
  }

  componentDidMount() {
    let activeFilter;
    let _this = this;

    this.lethargy = new Lethargy(); // Use defaults
    //this.lethargy = new Lethargy(7, 50, 0.2); // Tinkering with the options

    this.isTouch = "ontouchstart" in document.documentElement ? true : false;

    this.init();
    window.addEventListener("resize", this.resize);
    this.timer = 0;

    this.links = document.querySelectorAll(".Filters .Navigation a");
    this.filters = document.getElementById("filters");

    for (var i = 0; i < this.links.length; i++) {
      let el = this.links[i];
      if (el.className == "is-active") activeFilter = i;
    }

    activeFilter = document.querySelectorAll('.Filters .Navigation a.is-active')[0];

    setTimeout(function() {
      if(!_this.isTouch) {
          _this.toFilter(activeFilter);
      
      } else {
          //_this.scrollToElement(_this.links[activeFilter])
      }
    }, 200);

    window.filters = this;
  }

  componentDidUpdate() {
    let activeFilter;
    let _this = this;
    let links = document.querySelectorAll(".Filters .Navigation a");
    for (var i = 0; i < this.links.length; i++) {
      let el = this.links[i];
      if (el.className == "is-active") activeFilter = i;
    }

    if(this.isTouch)
    {
      // can't do this without creating an infinite loop

      /*let targetOffset = this.getOffset(this.links[activeFilter])
      let scrollTarget =
        targetOffset.left +
        targetOffset.width / 2 -
        window.innerWidth / 2 +
        this.curScroll;
      //this.setTlPos(this.links[activeFilter].getAttribute('data-left'))
      console.log('componentDidUpdate',this.links[activeFilter].getAttribute('data-left'))*/
    } else {
      //console.log('componentDidUpdate toFilter')
      _this.toFilter(activeFilter, false);
      _this.hasUpdated = true;
    }

    
  }

  componentWillUnmount() {
    this.destroy();
    window.removeEventListener("resize", this.resize);
  }

  init = () => {
    const tl = new TimelineMax({ paused: true });
    this.tl = tl;

    this.length = this.refs.mouseWheel.refs.el.offsetWidth;
    //console.log('MapFilters',this.length)

    if (this.props.onInit) this.props.onInit(this);
  };

  resize = () => {
    // Store previous progress
    let posWas = this.pos;
    let progressWas = this.progress;
    this.tl.progress(0);

    // Re initialise the Filters
    this.destroy();
    this.init();

    // Update the position as it was
    this.pos = this.length * progressWas;
    this.update();
  };

  setLength = len => {
    this.length = len;
    this.progress = this.pos / this.length;
  };

  destroy = () => {
    if (this.tl) this.tl.kill();
  };

  mouseWheel = ({ delta, e, swipe, type }) => {
    if (type == "wheel") {
      if (this.lethargy.check(e)) {
        if (delta > 1) this.nextFilter();
        else this.prevFilter();
      }
    } else {
      //if (this.lethargy.check(e)) {
      //console.log(delta)
      let pos = this.pos + delta;

      if (pos < 0) pos = 0;
      if (pos > this.length) pos = this.length;

      this.pos = pos;
      this.update();
    //}
    }
  };

  update = () => {
    //clearTimeout(this.timer)

    const scroll = this.pos;
    const dist = this.length;
    let _this = this;

    let progress = scroll / dist;

    //console.log(scroll, dist, progress)

    if (progress < 0) progress = 0;

    if (progress != this.progress) {
      this.progress = progress;

      // Seek the animation
      this.tl.progress(progress);

      if (this.props.onUpdate) {
        this.props.onUpdate(this);
      }
    } else {
      //console.log('paused?')
      //_this.snapTo()
          /*this.timer = setTimeout(function()
      {
          
      },300)*/
    }
  };

  nextFilter = () => {
    if (this.currentFilter + 1 > this.filters.length - 1 || this.isScrolling)
      return false;
    this.toFilter(this.currentFilter + 1);
    //this.links[this.currentFilter + 1].click()
  };

  prevFilter = () => {
    if (this.currentFilter - 1 < 0 || this.isScrolling) return false;
    this.links[this.currentFilter - 1].click();
    this.toFilter(this.currentFilter - 1);
  };

  toFilter = (filter, doClick = true) => {
    if (filter > this.links.length - 1) return;
      if (this.isScrolling) return;

      //console.log("scroll!");

      this.isScrolling = true;

      let _this = this;
      let target = this.links[filter];

      let targetOffset = this.getOffset(target);

      let scrollTarget =
        targetOffset.left +
        targetOffset.width / 2 -
        window.innerWidth / 2 +
        this.curScroll;

      this.filters.style.left = -scrollTarget + "px";

      this.curScroll = scrollTarget;
      this.currentFilter = filter;

      setTimeout(function() {
        _this.isScrolling = false;
        if (doClick) target.click();
      }, 300);
    
  };

  scrollToElement = (el) => {
    let targetOffset = this.getOffset(el)
      let scrollTarget =
        targetOffset.left +
        targetOffset.width / 2 -
        window.innerWidth / 2
      this.setTlPos(scrollTarget)


  }

  snapTo = () => {
    let _this = this;
    let windowWidth = window.innerWidth / 2;
    let offsets = [];
    let dists = [];

    //console.log("Pause time", this.tl.time());

    for (var i = 0; i < this.links.length; i++) {
      let offset = _this.getOffset(this.links[i]);
      offsets[i] = offset.left + offset.width / 2;
      dists[i] = Math.abs(windowWidth - offsets[i]);
    }

    let min = Math.min(...dists);
    let closestLinkIndex = dists.indexOf(min);



    let targetOffset = this.getOffset(this.links[closestLinkIndex])

    let scrollTarget =
        targetOffset.left +
        targetOffset.width / 2

    //console.log(this.links[closestLinkIndex],this.links[closestLinkIndex].getAttribute('data-left'),targetOffset.left)

    this.setTlPos(scrollTarget);

    this.links[closestLinkIndex].click();
  };

  setTlPos = (elementOffset, click = false) => {
    //console.log(elementOffset);
    let _this = this;
    let currentDuration = this.tl.duration();
    let closestOffset = elementOffset - window.innerWidth / 2;
    let newProgress = currentDuration / this.length * closestOffset;

    this.tl.duration(5);

    //console.log("New time", currentDuration);

    this.tl.tweenTo(newProgress, {
      onComplete: function() {
        _this.tl.duration(currentDuration);
      }
    });
  };

  getOffset = el => {
    let rect = el.getBoundingClientRect();
    return { top: rect.top, left: rect.left, width: rect.width };
  };

  /*
    
    RENDER

  */

  render() {
    return (
      <MouseWheel
        {...this.props}
        ref="mouseWheel"
        direction={"h"}
        onUpdate={this.mouseWheel}
      >
        {this.props.children}
      </MouseWheel>
    );
  }
}

export default MapFilters;


// WEBPACK FOOTER //
// ./src/js/components/MapFilters/MapFilters.jsx